  document.addEventListener('DOMContentLoaded', function () {
    const accordionItems = document.querySelectorAll('.accordion-item');

    accordionItems.forEach(function (item) {
      const trigger = item.querySelector('.accordion-trigger');

      trigger.addEventListener('click', function () {
        item.classList.toggle('active');
      });
    });
  });

  class AccordionToggle extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.header = this.querySelector(".accordion__header");
    this.content = this.querySelector(".accordion__content");

    this.handleClick = this.handleClick.bind(this);

    this.header.addEventListener("click", this.handleClick);

    this.addMaxHeight();
  }

  disconnectedCallback() {
    this.header.removeEventListener("click", this.handleClick);
  }

  handleClick() {
    if (this.classList.contains("accordion--open")) {
      this.classList.remove("accordion--open");
    } else {
      this.classList.add("accordion--open");
    }
  }

  addMaxHeight() {
    this.style.setProperty("--accordion-content-height", this.content.scrollHeight + "px");
  }
}

customElements.define("accordion-toggle", AccordionToggle);

document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll(".quantity-wrapper").forEach((wrapper) => {
    const input = wrapper.querySelector(".qty-input");
    const plus = wrapper.querySelector(".qty-plus");
    const minus = wrapper.querySelector(".qty-minus");

    const min = parseInt(input.min) || 1;
    const max = input.hasAttribute("max") ? parseInt(input.max) : null;

    // Initialize button states
    updateButtons();

    plus.addEventListener("click", () => {
      let value = parseInt(input.value) || min;
      if (max !== null && value >= max) return; // stop at max
      input.value = value + 1;
      updateButtons();
    });

    minus.addEventListener("click", () => {
      let value = parseInt(input.value) || min;
      if (value <= min) return;
      input.value = value - 1;
      updateButtons();
    });

    function updateButtons() {
      const value = parseInt(input.value) || min;
      minus.disabled = value <= min;
      if (max !== null) plus.disabled = value >= max;
    }
  });
});

document.addEventListener("DOMContentLoaded", () => {
  const overlay = document.getElementById("addToCartOverlay");
  const targetSection = document.getElementById("productInfo-container");

  if (!overlay || !targetSection) return;

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) {
          // User scrolled past the section → show overlay
          overlay.classList.add("active");
        } else {
          // Section is visible → hide overlay
          overlay.classList.remove("active");
        }
      });
    },
    {
      root: null, // viewport
      threshold: 0, // trigger as soon as section leaves viewport
    },
  );

  observer.observe(targetSection);
});

  window.Wishlist = window.Wishlist || {};

  Wishlist.init = function (root) {
    var STORAGE_KEY = 'wishlist-wolcompany';

    function readList() {
      try {
        return JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
      } catch (e) {
        return [];
      }
    }

    function writeList(list) {
      try {
        localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
      } catch (e) {}
    }

    function setState(btn, saved) {
      btn.classList.toggle('saved', saved);
      btn.setAttribute('aria-pressed', saved ? 'true' : 'false');
    }

    function toggleHandle(handle) {
      var list = readList();
      var i = list.indexOf(handle);
      if (i > -1) {
        list.splice(i, 1);
        writeList(list);
        return false;
      }
      list.push(handle);
      writeList(list);
      return true;
    }

    (root || document).querySelectorAll('.wishlist-button[data-product-handle]').forEach(function (btn) {
      var handle = btn.dataset.productHandle;
      var saved = readList().indexOf(handle) > -1;
      setState(btn, saved);

      if (!btn.__wishlistBound) {
        btn.addEventListener('click', function () {
          var nowSaved = toggleHandle(handle);
          setState(btn, nowSaved);

          // Remove from wishlist page UI
          if (document.body.classList.contains('template-wishlist') && !nowSaved) {
            btn.closest('.product-card')?.remove();
          }
        });
        btn.__wishlistBound = true;
      }
    });
  };

  // Run once on normal page load
  document.addEventListener('DOMContentLoaded', function () {
    Wishlist.init(document);
  });


